import { render, staticRenderFns } from "./ProductMasterPropagateModal.vue?vue&type=template&id=672cefae&scoped=true&"
import script from "./ProductMasterPropagateModal.vue?vue&type=script&lang=js&"
export * from "./ProductMasterPropagateModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductMasterPropagateModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductMasterPropagateModal.vue?vue&type=style&index=1&id=672cefae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cefae",
  null
  
)

/* custom blocks */
import block0 from "./ProductMasterPropagateModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VList,VListItem,VListItemContent,VListItemTitle})
